import { UnifiedJobStatus } from "@/models/interfaces/dtos/job";
import { sleep } from "@/utils/async-utils";

const POLLING_INTERVAL = 2000;
const MAX_RETRIES = 5;

// null signifie que le suivi a été interrompu par le démontage du composant.
const pollJob = <TJob>(
    fetchStatus: () => Promise<TJob | undefined>,
    getStatus: (job: TJob) => UnifiedJobStatus,
    isActive: () => boolean,
): Promise<TJob | null> => {
    let retries = 0;

    const checkStatus = async (): Promise<TJob | null> => {
        if (!isActive()) return null;

        let job: TJob | undefined;
        try {
            job = await fetchStatus();
            retries = 0;
        } catch (error) {
            if (!isActive()) return null;
            retries += 1;
            if (retries > MAX_RETRIES) throw error;
            await sleep(POLLING_INTERVAL);
            return checkStatus();
        }

        if (!isActive()) return null;
        if (!job) throw new Error("Job introuvable.");

        const status = getStatus(job);
        if (status === UnifiedJobStatus.Success || status === UnifiedJobStatus.Error) return job;

        // Seules les requêtes de statut sont réessayées, jamais les actions de fin.
        await sleep(POLLING_INTERVAL);
        return checkStatus();
    };

    return checkStatus();
};

export default pollJob;
